import { Box } from '@chakra-ui/react';
import React from 'react';

import { Icon } from './Icon';

type TagIconProps = React.ComponentProps<typeof Icon> & {
  placement?: 'left' | 'right';
};

/**
 * Icon for use inside a Chakra `<Tag>`, replacing Chakra's `TagLeftIcon` /
 * `TagRightIcon`.
 *
 * Chakra's Tag*Icon components render their children inside an `<svg>`
 * element. Self-hosted Font Awesome webfont glyphs are drawn via a CSS
 * `::before` pseudo-element, which only paints in the HTML namespace — so an
 * `<i>` nested inside an `<svg>` renders at zero width (invisible). This
 * wrapper keeps the icon in the HTML namespace (a `<span>`) while reproducing
 * Chakra's Tag icon spacing.
 *
 * @param placement "left" (default) mirrors TagLeftIcon; "right" mirrors TagRightIcon
 */
export const TagIcon = ({
  placement = 'left',
  ...iconProps
}: TagIconProps): React.ReactElement => (
  <Box
    as="span"
    display="inline-flex"
    verticalAlign="top"
    marginEnd={placement === 'left' ? '0.5rem' : undefined}
    marginStart={placement === 'right' ? '0.5rem' : undefined}
  >
    <Icon {...iconProps} />
  </Box>
);
